
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className={`text-2xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              ASISTEC
            </div>
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <a href="#servicios" className={`text-sm font-medium transition-colors hover:text-teal-600 whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Servicios
            </a>
            <a href="#nosotros" className={`text-sm font-medium transition-colors hover:text-teal-600 whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Nosotros
            </a>
            <a href="#proyectos" className={`text-sm font-medium transition-colors hover:text-teal-600 whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Proyectos
            </a>
            <a href="#contacto" className={`text-sm font-medium transition-colors hover:text-teal-600 whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Contacto
            </a>
          </div>

          <div className="flex items-center gap-3">
            <a 
              href="tel:628752701" 
              className="hidden sm:flex items-center gap-2 px-5 py-2.5 bg-teal-600 text-white text-sm font-medium rounded-full hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              628 752 701
            </a>
            <a 
              href="https://wa.me/34628752701" 
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-10 h-10 bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
